import { Gender, MaritalStatus, LicenseCategory, EmploymentStatus } from "@core/enums";

/**
 * Discriminateur PERSON / COMPANY (parite olive_customer.InsuredType).
 * `insuredType` est REQUIRED cote back lors d'un POST /app/insureds.
 */
export type InsuredType = 'PERSON' | 'COMPANY';

/**
 * Souscripteur (Insured) — source de verite vivante = olive_customer.
 *
 * Champs alignes sur {@code InsuredResponse} (back). Les champs marques
 * `// LEGACY` ne sont PLUS portes par olive_customer ; ils restent dans
 * l'interface tant que les ecrans legacy les consomment, mais retourneront
 * `''` apres la migration F13.
 */
export class Insured {
  id: string;
  uuid: string;
  /** Discriminateur metier — REQUIRED a la creation cote olive_customer. */
  insuredType: InsuredType;
  /** Libelle pre-calcule cote back ("First Last" pour PERSON, companyName pour COMPANY). */
  displayLabel: string;
  civility: string;
  lastName: string;
  firstName: string;
  birthDate: string;
  idDocumentType: string;
  idDocumentNumber: string;
  address: string;
  city: string;
  email: string;
  phone: string;
  landlinePhone: string;
  mobilePhone: string;
  profession: string;
  activity: string;
  socioProfessionalCategoryUuid: string;
  companyName: string;
  businessLicense: string;
  tradeRegister: string;
  defaultExemptionUuid: string;
  /** Reduction par defaut appliquee aux quittances (parite olive_customer). */
  defaultReductionUuid: string;
  /** Notation metier 0..6 etoiles (parite olive_customer.rating). 0 = non note. */
  rating: number;
  createdAt: string;
  updatedAt: string;

  // LEGACY — non portes par olive_customer (a supprimer en F13 si plus aucun ecran ne consomme).
  codeAssure: number;
  gender: Gender;
  maritalStatus: MaritalStatus;
  postalCode: string;
  licenseNumber: string;
  licenseIssueDate: string;
  licenseCategory: LicenseCategory;
  registrationDate: string;
  employmentStatus: EmploymentStatus;
  managementEntity: string;

  constructor(data: any) {
    this.id = data.id || data.uuid || '';
    this.uuid = data.uuid || data.id || '';
    this.insuredType = (data.insuredType as InsuredType) || (data.companyName ? 'COMPANY' : 'PERSON');
    this.displayLabel = data.displayLabel
      || (data.companyName || `${data.firstName ?? ''} ${data.lastName ?? ''}`.trim())
      || '';
    this.civility = data.civility || '';
    this.lastName = data.lastName || '';
    this.firstName = data.firstName || '';
    this.birthDate = data.birthDate || '';
    this.idDocumentType = data.idDocumentType || '';
    this.idDocumentNumber = data.idDocumentNumber || '';
    this.address = data.address || '';
    this.city = data.city || '';
    this.email = data.email || '';
    this.phone = data.phone || data.mobilePhone || '';
    this.landlinePhone = data.landlinePhone || '';
    this.mobilePhone = data.mobilePhone || '';
    this.profession = data.profession || '';
    this.activity = data.activity || '';
    this.socioProfessionalCategoryUuid = data.socioProfessionalCategoryUuid || '';
    this.companyName = data.companyName || '';
    this.businessLicense = data.businessLicense || '';
    this.tradeRegister = data.tradeRegister || '';
    this.defaultExemptionUuid = data.defaultExemptionUuid || '';
    this.defaultReductionUuid = data.defaultReductionUuid || '';
    this.rating = data.rating ?? 0;
    this.createdAt = data.createdAt || '';
    this.updatedAt = data.updatedAt || '';

    // LEGACY
    this.codeAssure = data.codeAssure || 0;
    this.gender = data.gender || '';
    this.maritalStatus = data.maritalStatus || '';
    this.postalCode = data.postalCode || '';
    this.licenseNumber = data.licenseNumber || '';
    this.licenseIssueDate = data.licenseIssueDate || '';
    this.licenseCategory = data.licenseCategory || '';
    this.registrationDate = data.registrationDate || '';
    this.employmentStatus = data.employmentStatus || '';
    this.managementEntity = data.managementEntity || '';
  }
}
